<template>
  <a-modal
    :title="title"
    :visible="visible"
    @cancel="handleCancel"
    @ok="handleCancel"
    @close="handleCancel"
    width="1200px">
    <a-table
      bordered
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :pagination="false"
      :loading="loading">
    </a-table>
    <div style="height: 25px"></div>
    <div class="bottom-control">
      <a-space>
        <a-button type="dashed" @click="handleCancel">{{$t('取消')}}</a-button>
      </a-space>
    </div>
  </a-modal>
</template>

<script>
import {subInfo} from '@/api/shop/extraApplyLakala'

export default {
  name: 'SubInfoList',
  props: {},
  data() {
    return {
      title: undefined,
      loading: false,
      visible: false,
      queryParam: {
        id: undefined,
        pageNum: 1,
        pageSize: 10
      },
      list: [],
      columns: [
        { title: '渠道', dataIndex: 'registerTypeText' },
        { title: '子商户号', dataIndex: 'subMchId' },
        { title: 'channelId', dataIndex: 'channelId' },
        { title: '注册渠道', dataIndex: 'registerChannelText' },
        { title: 'receOrgNo', dataIndex: 'receOrgNo' },
        { title: '注册时间', dataIndex: 'registerTm' },
        { title: '注册状态', dataIndex: 'registerStatus' },
        { title: 'resultMessage', dataIndex: 'resultMessage' },
      ],
    }
  },
  methods: {
    handleCancel() {
      this.visible = false
      this.list = []
      this.reset()
    },
    reset() {
      this.form = { orderId: undefined, addressId: undefined, isAdmin: true }
    },
    handleDetail(id) {
      this.queryParam.id = id
      subInfo(this.queryParam).then(res => {
        this.list = res.data.respData.list
        this.visible = true;
      }).finally(() => {
        this.loading = false
      });
    },
  }
}
</script>
